import type { LocationsResponse, MenuType } from '@/types/widget'

/**
 * Resolves the full list of ecom providers that should have interceptors installed.
 *
 * Priority:
 *  1. Known sub-location (globalID + menuType) -> single provider
 *  2. Known UID -> providers from that ecom location
 *  3. Top-level providers across all locations
 */
export function resolveEcomProviders(
  data: LocationsResponse,
  currentGlobalID?: string,
  currentMenuType?: MenuType,
  currentUID?: string
): string[] {
  if (currentGlobalID && currentMenuType) {
    const location = data.ecomLocations?.find((loc) => loc.globalID === currentGlobalID)
    const sub = location?.subEcomLocations?.find((s) => s.menuType === currentMenuType)
    if (sub?.ecomMenuProvider) {
      return [sub.ecomMenuProvider]
    }
  }

  if (currentUID) {
    const location = data.ecomLocations?.find((loc) => loc.uid === currentUID)
    if (location?.ecomMenuProviders?.length) {
      return location.ecomMenuProviders
    }
  }

  return data.ecomMenuProviders ?? []
}

/**
 * Resolves a single "current" ecom provider for the active session context.
 * Used to persist in the session store so aiq-pixel can read it from localStorage.
 */
export function resolveCurrentEcomProvider(
  data: LocationsResponse,
  currentGlobalID?: string,
  currentMenuType?: MenuType,
  currentUID?: string
): string | undefined {
  const providers = resolveEcomProviders(data, currentGlobalID, currentMenuType, currentUID)
  return providers[0]
}
